import React, { useState, useCallback } from 'react';
import iconStandard from 'assets/images/icons_svg/icon_journal_standard_selection.svg';
import iconMission from 'assets/images/icons_svg/icon_journal_mission_selection.svg';
import iconRadioSelected from 'assets/images/icons_svg/Radio.svg';
import iconRadioUnselected from 'assets/images/icons_svg/Radio_2.svg';
import './AddJournalSelectionDialog.css';

const AddJournalSelectionDialog = ({ close, onSelect }) => {
    const [selection, setSelection] = useState('standard');

    const _close = useCallback(() => {
        if (close) {
            close();
        }
    }, [close]);

    const _onAdd = useCallback(() => {
        if (onSelect) {
            onSelect(selection);
        }
    }, [onSelect, selection]);

    return (
        <div
            id="add-journal-selection-modal"
            className="modal-frame centered-modal-frame"
        >
            <div className="modal-box modal-box--selection">
                <div className="modal__header">Add a Journal</div>
                <div className="modal__body selection-modal-body">
                    <div className="journal-selection-container">
                        {/* Standard Journal Card */}
                        <div className="selection-card-wrapper">
                            <div
                                className={`selection-card ${
                                    selection === 'standard' ? 'selected' : ''
                                }`}
                                onClick={() => setSelection('standard')}
                            >
                                <div className="selection-card__radio">
                                    <img
                                        src={
                                            selection === 'standard'
                                                ? iconRadioSelected
                                                : iconRadioUnselected
                                        }
                                        alt="Radio"
                                    />
                                </div>
                                <div className="selection-card__icon">
                                    <img
                                        src={iconStandard}
                                        alt="Standard Journal"
                                    />
                                </div>
                            </div>
                            <div className="selection-card__label">
                                Standard Journal
                            </div>
                        </div>

                        {/* Mission JRNL Card */}
                        <div className="selection-card-wrapper">
                            <div
                                className={`selection-card ${
                                    selection === 'mission' ? 'selected' : ''
                                }`}
                                onClick={() => setSelection('mission')}
                            >
                                <div className="selection-card__radio">
                                    <img
                                        src={
                                            selection === 'mission'
                                                ? iconRadioSelected
                                                : iconRadioUnselected
                                        }
                                        alt="Radio"
                                    />
                                </div>
                                <div className="selection-card__icon">
                                    <img src={iconMission} alt="Mission JRNL" />
                                </div>
                            </div>
                            <div className="selection-card__label">
                                Mission JRNL
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal__footer">
                    <button className="btn btn-outline" onClick={_close}>
                        Cancel
                    </button>
                    <button className="btn btn-gradient" onClick={_onAdd}>
                        Select
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddJournalSelectionDialog;
